import { makeStyles } from 'makeStyles';
import { TEXT_MAIN } from 'theme/colors';

export const useStyles = makeStyles()(() => ({
  tableHeading: {
    // alignSelf: 'center',
    flexGrow: 0,
    fontSize: 13,
    fontWeight: 900,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.4,
    letterSpacing: 'normal',
    // textAlign: 'left',
    color: '#3e424e',
  },
  count: {
    fontSize: 16,
    color: TEXT_MAIN,
    // display: 'inline'
  },
  formLabelText: {
    margin: '8px 0 8px 0',
    fontSize: 13,
    fontWeight: 900,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.4,
    letterSpacing: 'normal',
    color: '#3e424e',
  },
  formLabelTextLarge: {
    margin: '8px 0 8px 0',
    fontSize: 14,
    fontWeight: 900,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.4,
    letterSpacing: 'normal',
    color: '#3e424e',
  },
  formSecondaryText: {
    fontSize: 13,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 0.26,
    color: '#737680',
  },
  h2: {
    fontSize: 24,
    fontWeight: 900,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  h4: {
    fontSize: 16,
    fontWeight: 900,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  h5: {
    fontSize: 14,
    fontWeight: 900,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  bodySmall: {
    fontSize: 13,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  bodySmallBold: {
    fontSize: 13,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 900,
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  bodySmallLight: {
    fontSize: 13,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 900,
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#737680',
  },
  bodyRegular: {
    fontSize: 14,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  bodyRegularLight: {
    fontSize: 14,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#737680',
  },
  bodyRegularBold: {
    fontSize: 14,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 'bold',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#3e424e',
  },
  h1: {
    fontSize: 32,
    fontHeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 900,
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  h3: {
    fontSize: 20,
    fontHeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 900,
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  bodyLarge: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  bodyXLarge: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  bodyLargeBold: {
    fontSize: 15,
    fontStretch: 'normal',
    fontStyle: 'normal',
    fontWeight: 900,
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#2d3236',
  },
  bodyLargeLight: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: '#737680',
  },
  bodyLargeDark: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.6,
    letterSpacing: 'normal',
    color: TEXT_MAIN,
  },
  selectLabel: {
    fontSize: 15,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#3e424e',
    marginRight: 30,
  },
  bold: {
    fontWeight: 900,
  },
}));
